import { render, staticRenderFns } from "./EditLocationCatalogue.vue?vue&type=template&id=4cf7f958&scoped=true&"
import script from "./EditLocationCatalogue.vue?vue&type=script&lang=ts&"
export * from "./EditLocationCatalogue.vue?vue&type=script&lang=ts&"
import style0 from "./EditLocationCatalogue.vue?vue&type=style&index=0&id=4cf7f958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf7f958",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf7f958')) {
      api.createRecord('4cf7f958', component.options)
    } else {
      api.reload('4cf7f958', component.options)
    }
    module.hot.accept("./EditLocationCatalogue.vue?vue&type=template&id=4cf7f958&scoped=true&", function () {
      api.rerender('4cf7f958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/EditLocationCatalogue.vue"
export default component.exports